import { DrawerType } from "@ryde/shared";

import { HelpTopicDrawer } from "../help-topics";
import {
  AddNewBulkBookings,
  AdministrativeModeDrawer,
  AiConversationDetailsDrawerWrapper,
  ApiKeyCreateDrawer,
  BackupCreateDrawer,
  BookingEditFormDrawer,
  BulkCreateBookings,
  BulkDriversMessageDrawer,
  BulkPassengerActivateShiftTemplateDrawer,
  BulkPassengerNearBySearchDrawer,
  BulkPassengersMessageDrawer,
  BulkUpdateBookingsDateTime,
  BulkUploadBookings,
  CopyToSupplierPriceRatesDrawer,
  CourseEditFormDrawer,
  CourseSchedulesPreviewDrawer,
  DrawerBookingsProduction,
  DrawerCoursesCalendarRideProduce,
  DrawerCustomProduction,
  DrawerEditForm,
  DrawerNewOrDuplicate,
  EditAreaWaypointsDrawer,
  EtlViewLogsDrawer,
  GenericExportDrawer,
  GenericUploadDrawer,
  HistoryLogDrawer,
  HubStationsInfoDrawer,
  ImportAreasDrawer,
  ImportBusStationsDrawer,
  JourneyDuplicateFormDrawer,
  JourneyEditFormDrawer,
  NotificationEditFormDrawer,
  NotificationsDrawer,
  PriceRateSearchLogsDrawer,
  ProductionPreview,
  ProductionViewLogsDrawer,
  RelatedEntitiesDrawer,
  RideEditFormDrawer,
  RideHistoryLogDrawer,
  StationRouteEditFormDrawer,
  SupplierPriceRatesPasswordDrawer,
  UpdateBasePriceDrawer,
  UserActionsHistoryDrawer,
} from "./components";
import { ProcessDrawer } from "./components/process";

export const drawersRegister = {
  [DrawerType.AddNewBulkBookings]: AddNewBulkBookings,
  [DrawerType.BookingsProduction]: DrawerBookingsProduction,
  [DrawerType.BulkCreateBookings]: BulkCreateBookings,
  [DrawerType.BulkUploadBookings]: BulkUploadBookings,
  [DrawerType.BulkUpdateBookingsDateTime]: BulkUpdateBookingsDateTime,
  [DrawerType.CustomProduction]: DrawerCustomProduction,
  [DrawerType.EditForm]: DrawerEditForm,
  [DrawerType.HistoryLog]: HistoryLogDrawer,
  [DrawerType.NewOrDuplicate]: DrawerNewOrDuplicate,
  [DrawerType.Notifications]: NotificationsDrawer,
  [DrawerType.NotificationEditForm]: NotificationEditFormDrawer,
  [DrawerType.ProductionPreview]: ProductionPreview,
  [DrawerType.ProductionViewLogs]: ProductionViewLogsDrawer,
  [DrawerType.EtlViewLogs]: EtlViewLogsDrawer,
  [DrawerType.PriceRateSearchLogs]: PriceRateSearchLogsDrawer,
  [DrawerType.GenericExport]: GenericExportDrawer,
  [DrawerType.GenericUpload]: GenericUploadDrawer,
  [DrawerType.BulkPassengerNearBySearch]: BulkPassengerNearBySearchDrawer,
  [DrawerType.BulkPassengersMessage]: BulkPassengersMessageDrawer,
  [DrawerType.BulkDriversMessage]: BulkDriversMessageDrawer,
  [DrawerType.RideEditForm]: RideEditFormDrawer,
  [DrawerType.BookingEditForm]: BookingEditFormDrawer,
  [DrawerType.CourseEditForm]: CourseEditFormDrawer,
  [DrawerType.CoursesCalendarRideProduce]: DrawerCoursesCalendarRideProduce,
  [DrawerType.JourneyEditForm]: JourneyEditFormDrawer,
  [DrawerType.JourneyDuplicate]: JourneyDuplicateFormDrawer,
  [DrawerType.StationRouteEditForm]: StationRouteEditFormDrawer,
  [DrawerType.UpdateBasePrice]: UpdateBasePriceDrawer,
  [DrawerType.ImportAreas]: ImportAreasDrawer,
  [DrawerType.ImportBusStations]: ImportBusStationsDrawer,
  [DrawerType.ProcessDrawer]: ProcessDrawer,
  [DrawerType.RideHistoryLog]: RideHistoryLogDrawer,
  [DrawerType.AdministrativeMode]: AdministrativeModeDrawer,
  [DrawerType.SupplierPriceRatesPassword]: SupplierPriceRatesPasswordDrawer,
  [DrawerType.CopyToSupplierPriceRates]: CopyToSupplierPriceRatesDrawer,
  [DrawerType.BackupCreate]: BackupCreateDrawer,
  [DrawerType.ApiKeyCreate]: ApiKeyCreateDrawer,
  [DrawerType.AiConversationDetails]: AiConversationDetailsDrawerWrapper,
  [DrawerType.BulkActivateShiftTemplate]:
    BulkPassengerActivateShiftTemplateDrawer,
  [DrawerType.UserActionsHistory]: UserActionsHistoryDrawer,
  [DrawerType.HelpTopic]: HelpTopicDrawer,
  [DrawerType.HubStationsInfo]: HubStationsInfoDrawer,
  [DrawerType.CourseSchedulesPreview]: CourseSchedulesPreviewDrawer,
  [DrawerType.RelatedEntities]: RelatedEntitiesDrawer,
  [DrawerType.EditAreaWaypoints]: EditAreaWaypointsDrawer,
} as const;
